import request from '@/utils/request'

// 查询部门列表
export function listDeptTree(data) {
  return request({
    url: 'addressBook/addressBookDept/deptTree',
    method: 'post',
    data,
  })
}

// 查询部门详细
export function getDept(deptId) {
  return request({
    url: 'addressBook/addressBookDept/' + deptId,
    method: 'get',
  })
}

// 新增部门
export function addDept(data) {
  return request({
    url: 'addressBook/addressBookDept/insert',
    method: 'post',
    data: data,
  })
}

// 修改部门
export function updateDept(data) {
  return request({
    url: 'addressBook/addressBookDept/update',
    method: 'post',
    data: data,
  })
}

// 删除部门
export function delDept(data) {
  return request({
    url: 'addressBook/addressBookDept/delete',
    method: 'post',
    data,
  })
}

// 获取用户信息
export function getInfoByPhone(data) {
  return request({
    url: 'addressBook/addressBookUser/getInfoByPhone',
    method: 'post',
    data,
  })
}

// 查询人员列表
export function listUser(data) {
  return request({
    url: 'addressBook/addressBookUser/list',
    method: 'post',
    data,
  })
}

// 查询人员详细
export function getUser(userId) {
  return request({
    url: 'addressBook/addressBookUser/' + userId,
    method: 'get',
  })
}

// 新增人员
export function addUser(data) {
  return request({
    url: 'addressBook/addressBookUser/insert',
    method: 'post',
    data: data,
  })
}

// 修改人员
export function updateUser(data) {
  return request({
    url: 'addressBook/addressBookUser/update',
    method: 'post',
    data: data,
  })
}

// 删除人员
export function delUser(data) {
  return request({
    url: 'addressBook/addressBookUser/delete',
    method: 'post',
    data,
  })
}

// 重置密码
export function resetUserPwd(data) {
  return request({
    url: 'addressBook/addressBookUser/resetPwd',
    method: 'post',
    data,
  })
}
